// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","565":"component---src-templates-page-js"}[chunkId] + "-" + {"532":"5fde45836f4ff76449d3","565":"21aa4e1a948dd47603fa"}[chunkId] + ".js";
};